"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    useChatMessagesState: ()=>useChatMessagesState
});
const external_react_namespaceObject = require("react");
const sanitizeInput_js_namespaceObject = require("../utils/sanitizeInput.js");
var sanitizeInput_js_default = /*#__PURE__*/ __webpack_require__.n(sanitizeInput_js_namespaceObject);
const useChatMessagesState = (props)=>{
    const { submitChatMessagesPayload } = props;
    const [chatMessages, setChatMessages] = (0, external_react_namespaceObject.useState)([]);
    const [santizedSubmitChatMessagesPayload, setSanitizedSubmitChatMessagesPayload] = (0, external_react_namespaceObject.useState)(submitChatMessagesPayload);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (!submitChatMessagesPayload) return;
        const { isPortal = false } = submitChatMessagesPayload;
        let updatedPayload = {
            ...submitChatMessagesPayload
        };
        if (updatedPayload.pushPrompt && !isPortal) updatedPayload = {
            ...updatedPayload,
            pushPrompt: sanitizeInput_js_default()(updatedPayload.pushPrompt)
        };
        setSanitizedSubmitChatMessagesPayload(updatedPayload);
    }, [
        submitChatMessagesPayload
    ]);
    return {
        chatMessages,
        setChatMessages,
        santizedSubmitChatMessagesPayload,
        setSanitizedSubmitChatMessagesPayload
    };
};
exports.useChatMessagesState = __webpack_exports__.useChatMessagesState;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "useChatMessagesState"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
